// extracted by mini-css-extract-plugin
export default {"wrapper":"ny-z","viewport":"oy-z","container":"py-z","slide":"qy-z"};